export default __webpack_public_path__ + "static/media/kishore.5ce94ddd.jpg";